// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3qfm9","colMin":"styles_colMin__3QdfM","colCheckbox":"styles_colCheckbox__3sy5Y"};